import { render, staticRenderFns } from "./PreviewBar.vue?vue&type=template&id=160fdb2b&"
import script from "./PreviewBar.vue?vue&type=script&lang=js&"
export * from "./PreviewBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports